// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2680":"ceb297d5","4480":"ceb297d5","6868":"e1d288bd"}[chunkId] + ".chunk.css";
};